import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/context/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Countries from "@/pages/Countries";
import CountryPage from "@/pages/CountryPage";
import QuestionDetail from "@/pages/QuestionDetail";
import Profile from "@/pages/Profile";
import Committee from "@/pages/Committee";
import Admin from "@/pages/Admin";
import Registry from "@/pages/Registry";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/countries" element={<Countries />} />
              <Route path="/country/:code" element={<CountryPage />} />
              <Route path="/question/:id" element={<QuestionDetail />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/committee" element={<Committee />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/registry" element={<Registry />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
